import React from "react";
import { useStickyState } from "@/hooks/useStickyState";
import { DefaultFilterPin, useDefaultFilter } from "@/components/DefaultFilterPin";

/** Status-Pills mit «Als Standard»-Pin – merkt sich pro Nutzer & Firma, womit die Seite öffnet. */
export function useStatusPills(prefKey, companyId, defaultValue = "all") {
  const [value, setValue] = useStickyState(prefKey, defaultValue, companyId);
  const def = useDefaultFilter(prefKey, companyId, value, setValue);
  return { value, setValue, def };
}

export function StatusFilterPills({ label = "Status:", options, value, onChange, def, testidPrefix }) {
  const current = options.find((o) => o.key === value);
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testidPrefix}-filter-bar`}>
      <span className="text-xs text-slate-500 mr-1">{label}</span>
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${value === opt.key ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"}`}
          data-testid={`${testidPrefix}-filter-${opt.key}`}
        >
          {opt.label}{opt.count != null ? ` (${opt.count})` : ""}
        </button>
      ))}
      {def && (
        <DefaultFilterPin value={value} label={current?.label || value} defaultValue={def.defaultValue} isDefault={def.isDefault} onSave={def.save} testId={`${testidPrefix}-default-filter-pin`} />
      )}
    </div>
  );
}
